import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-popup',
  templateUrl: './update-popup.component.html',
  styleUrls: ['./update-popup.component.css']
})
export class UpdatePopupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
